import { useState } from 'react';
import axios from 'axios';

const useProductSearch = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 10; // Número de produtos por página

    const searchProducts = async (query, page = 1) => {
        setLoading(true);
        setError(null);
        try {
            const offset = (page - 1) * limit;
            const response = await axios.get('https://api.mercadolibre.com/sites/MLB/search', {
                params: {
                    q: query,
                    offset,
                    limit
                }
            });

            const totalResults = response.data.paging.total;
            setTotalPages(Math.ceil(totalResults / limit));

            const enhancedProducts = await Promise.all(
                response.data.results.map(async (product) => {
                    const sellerResponse = await axios.get(`https://api.mercadolibre.com/users/${product.seller.id}`);
                    return {
                        id: product.id,
                        title: product.title,
                        thumbnail: product.thumbnail,
                        price: product.price,
                        sellerRating: sellerResponse.data.seller_reputation.level_id, // Nível da reputação do vendedor
                        sellerName: sellerResponse.data.nickname, // Nome do vendedor
                        sellerLocation: sellerResponse.data.address.state_name, // Localização do vendedor
                        link: product.permalink
                    };
                })
            );

            setProducts(enhancedProducts);
        } catch (err) {
            console.error('Error fetching products:', err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    return { products, searchProducts, loading, error, page, setPage, totalPages };
};

export default useProductSearch;
